import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const StepsPage = lazy(() => import("./StepsPage"));

const StepsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <StepsPage />
    </Suspense>
  );
};

export default StepsPageLazy;
